// extracted by mini-css-extract-plugin
export var menuIcon = "_s0-0";
export var menuIconInline = "_s0-1";